export const setLatestVersionId = (state, payload) => {
    state.latestVersionId = payload;
};
